import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boolToText',
  standalone: true
})
export class BoolToTextPipe implements PipeTransform {
  transform(value: boolean, trueText: string = 'Yes', falseText: string = 'No'): string {
    return value ? trueText : falseText;
  }
}